export default {
    id: "d3f8c4e2-9b7a-4f1a-8c2b-91e7a4f0d6b3",
    icon: "mdi-flip-horizontal",
    name: "flipCardEnhanced",
    title: "Flip Card Enhanced",
    description: "An enhanced FlipCard component"
}